<a *ngIf="thumbnailUrl" href="{{href}}" target="{{target}}" (click)="click()">
    <img [src]="thumbnailUrl | secure | async">
</a>

<img *ngIf="thumbnailUrl && !href" [src]="thumbnailUrl | secure | async">